import React, { useState, useEffect } from "react";
import Login from "./components/login.js";
import SignupScreen from "./components/signup.js";
import Payment from "./components/payment.js";
import Sidebar from "./components/Sidebar.js";
import Send from "./components/Send.js";
import Receive from "./components/Receive.js";
import Transactions from "./components/Transactions.js";
import StoredFiles from "./components/StoredFiles.js";
import AdminDashboard from "./components/AdminDashboard.js";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [activeTab, setActiveTab] = useState("Send");
  const [screen, setScreen] = useState("Login");
  const [pendingPaymentUserId, setPendingPaymentUserId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    
    if (token) {
      setIsAuthenticated(true);
      if (role === "admin") {
        setIsAdmin(true);
      }
    }
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    setIsAdmin(false);
  };

  const handleAdminLogin = () => {
    setIsAuthenticated(true);
    setIsAdmin(true);
  };

  const handleGoToPayment = (userId) => {
    setPendingPaymentUserId(userId);
    setScreen("Payment");
  };

  const handlePaymentSuccess = () => {
    alert("Payment successful! Please login again.");
    setPendingPaymentUserId(null);
    setScreen("Login");
  };

  const handlePaymentCancel = () => {
    setPendingPaymentUserId(null);
    setScreen("Login");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
    setIsAuthenticated(false);
    setIsAdmin(false);
    setActiveTab("Send");
    setScreen("Login");
  };

  const styles = {
    app: {
      display: "flex",
      minHeight: "100vh",
      backgroundColor: "#f4f4f9",
    },
    mainContent: {
      flex: 1,
      padding: "20px",
    },
  };

  // Auth screens handling
  if (!isAuthenticated) {
    return (
      <div style={styles.app}>
        <div style={styles.mainContent}>
          {screen === "Login" ? (
            <Login
              setActiveTab={setActiveTab}
              onLogin={handleLogin}
              onAdminLogin={handleAdminLogin}
              goToSignup={() => setScreen("Signup")}
              goToPayment={handleGoToPayment}
            />
          ) : screen === "Signup" ? (
            <SignupScreen 
              goToLogin={() => setScreen("Login")}
              goToPayment={handleGoToPayment}
            />
          ) : screen === "Payment" ? (
            <Payment
              userId={pendingPaymentUserId}
              onPaymentSuccess={handlePaymentSuccess}
              onCancel={handlePaymentCancel}
            />
          ) : null}
        </div>
      </div>
    );
  }

  // Admin Dashboard
  if (isAdmin) {
    return (
      <div style={styles.app}>
        <AdminDashboard onLogout={handleLogout} />
      </div>
    );
  }

  // Regular User - Main app after login
  return (
    <div style={styles.app}>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={handleLogout} />
      <div style={styles.mainContent}>
        {activeTab === "Send" && <Send />}
        {activeTab === "Receive" && <Receive />}
        {activeTab === "Transactions" && <Transactions />}
        {activeTab === "Stored Files" && <StoredFiles />}
      </div>
    </div>
  );
}

export default App;